module.exports = __webpack_public_path__ + "static/media/covi_ppe_dis_ove.4852c4bb.png";